// Datos de la empresa dueña del producto Bonsai
export const COMPANY = {
  NAME: "Sinapsistemas",
  WEB_URL: "https://www.sinapsistemas.com",
  WEB_LABEL: "www.sinapsistemas.com",
  WHATSAPP_URL: "https://api.whatsapp.com/send?phone=59899539494",
};
